import React, { Component } from 'react'
import "./style.css"


class SFTable extends Component {

    constructor(props) {
        super(props)
    }


    render() {

        return (
            <div className='sf-table'>
                {/* Column header */}
                <div className='sf-table-header mt-1'>
                    {this.props?.columns?.map((col, index) => (
                        <div key={index} className='sf-table-header-div'
                            style={{
                                textAlign: 'center',
                                width: col.width,
                                opacity: col.visible === false ? 0 : 1,
                            }}>
                            {col.name}
                        </div>
                    ))}
                </div>
                <div className='sf-table-row-container ' style={this.props?.tableStyle}>
                    {this.props?.dataArr?.map((data, index) => (
                        <div key={index} >
                            {this.props.renderRow(data, index, this.props.isInstructor, this.props)}
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}


export default SFTable;